import pickBy from 'lodash.pickby';

const getters = {
  auctionFunNotificationViewed: (state) => (auctionId) => Object
    .prototype
    .hasOwnProperty
    .call(state.viewedAuctionIds, auctionId),
};

const mutations = {
  addFunNotification(state, auctionId) {
    const expirationDateTime = new Date();
    expirationDateTime.setDate(expirationDateTime.getDate() + 7);
    state.viewedAuctionIds[auctionId] = expirationDateTime.getTime();
  },
  setViewedAuctionIds(state, viewedAuctionIds) {
    state.viewedAuctionIds = viewedAuctionIds;
  },
};

const actions = {
  setAuctionIdFunNotificationViewed({ commit }, auctionId) {
    commit('addFunNotification', auctionId);
  },
  clearExpiredAuctionFunModals({ commit, state }) {
    const now = Date.now();
    const nonExpiredViewedAuctionIds = pickBy(
      state.viewedAuctionIds,
      (expirationDate) => now < expirationDate,
    );
    commit('setViewedAuctionIds', nonExpiredViewedAuctionIds);
  },
  startClearViewedFunNotificationsInterval({ dispatch }) {
    const OneDayInMilleseconds = 1000 * 60 * 60 * 24;
    dispatch('clearExpiredAuctionFunModals');
    setInterval(() => {
      dispatch('clearExpiredAuctionFunModals');
    }, OneDayInMilleseconds);
  },
};

const state = {
  viewedAuctionIds: {},
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
